var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'input-div mb-4' + _vm.inputClass},[_c('input',{attrs:{"type":_vm.type,"name":_vm.name,"require":"","required":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }